import React from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import { Grid, Row } from '@ublique/components/Grid'

import Footer from '../components/Footer'
import JobData from '../components/JobData'
import Crontab from './Crontab'

import { useCronScheduledForm } from '../utils/form'

const Creation = ({
  onSubmit,
  changeOpen,
  defaultScheduledData,
  jobTypes,
  isScheduledEditing
}) => {
  const { t: tWizard } = useTranslation('WizardPlatform')

  const t = (label) => tWizard(`Scheduled.${label}`)

  const {
    values,
    setFieldValue,
    onFormSubmit,
    submitted,
    cronSettingsEnabled,
    enableCronSettings
  } = useCronScheduledForm({
    onSubmit,
    isScheduledEditing,
    defaultScheduledData
  })

  const hancleClose = () => {
    changeOpen(false)
  }

  return (
    <Grid id='scheduled-grid'>
      <form onSubmit={onFormSubmit} autoComplete='off'>
        <div className='form-container'>
          <JobData
            t={t}
            jobType={values.jobType}
            mailTo={values.mailTo}
            jobTypes={jobTypes}
            setFieldValue={setFieldValue}
            submitted={submitted}
          />
          <Crontab
            t={t}
            cronSettingsEnabled={cronSettingsEnabled}
            enableCronSettings={enableCronSettings}
            cronStart={values.cronStart}
            cronEnd={values.cronEnd}
            monthdays={values.monthdays}
            minutes={values.minutes}
            hours={values.hours}
            months={values.months}
            weekdays={values.weekdays}
            timezone={values.timezone}
            setFieldValue={setFieldValue}
            submitted={submitted}
            defaultScheduledData={defaultScheduledData}
            isScheduledEditing={isScheduledEditing}
          />
          <Row className='last-line'>
            <hr />
          </Row>
        </div>
        <Footer t={t} onCancel={hancleClose} />
      </form>
    </Grid>
  )
}

Creation.propTypes = {
  clones: PropTypes.arrayOf(PropTypes.object),
  onSubmit: PropTypes.func,
  changeOpen: PropTypes.func
}

Creation.defaultProps = {
  clones: [],
  onSubmit: () => {},
  changeOpen: () => {}
}

export default React.memo(Creation)
